document.addEventListener('DOMContentLoaded', function() {


  // Event listener for Add to Cart button
  document.querySelectorAll('.add-to-cart-btn').forEach(button => {
    button.addEventListener('click', function() {
      const variantId = this.getAttribute('data-variant-id');
      
      // Call function to add product to cart
      addToCart(variantId);
    });
  });
  
  // Function to add product to cart using Shopify's Ajax API
  function addToCart(variantId) {

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      
      // Update cart content dynamically
      updateCart(variantId);
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }

  // Function to open the cart drawer
  // function openCartDrawer() {
  //   const cartDrawer = document.querySelector('.cart-drawer');
    
  //   if (cartDrawer) {
  //     cartDrawer.classList.add('open'); // Adjust based on your drawer implementation
  //   }
  // }

  // Function to fetch and update cart content dynamically
  function updateCart(variantId) {


    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(cart => {
      console.log('Updated cart:', cart);
      // publish(PUB_SUB_EVENTS.cartUpdate, {
      //   source: 'product-form',
      //   productVariantId: variantId,
      //   cartData: response,
      // });
    
      // Update the cart item count
      const cartItemCountElement = document.querySelector('.cart-item-count');
     
      if (cartItemCountElement) {
        cartItemCountElement.textContent = cart.item_count;
      }
        console.log(Shopify.formatMoney(cart.total_price))
      
      // Update the cart total price
      // const cartTotalElement = document.querySelector('.cart-total-price');
      // if (cartTotalElement) {
      //   cartTotalElement.textContent = Shopify.formatMoney(cart.total_price);
      // }

    

      // Optionally update cart items list if you have a section displaying the items
      // const cartItemsContainer = document.querySelector('.cart-items');
      // if (cartItemsContainer) {
      //   cartItemsContainer.innerHTML = ''; // Clear existing items
      //   cart.items.forEach(item => {
      //     const itemElement = document.createElement('div');
      //     itemElement.className = 'cart-item';
      //     itemElement.innerHTML = `
      //       <div class="cart-item-title">${item.product_title}</div>
      //       <div class="cart-item-quantity">${item.quantity}</div>
      //       <div class="cart-item-price">${Shopify.formatMoney(item.final_line_price)}</div>
      //     `;
      //     cartItemsContainer.appendChild(itemElement);
      //   });
      // }
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });
  }
});
